const focusVisibleClass = "focus-visible";
const addFocusVisible = (element) => {
  element.classList.add(focusVisibleClass);
  element.setAttribute("data-focus-visible-added", "");
};
const removeFocusVisible = (element) => {
  if (element.classList.contains(focusVisibleClass)) {
    element.classList.remove(focusVisibleClass);
    element.removeAttribute("data-focus-visible-added");
  }
};
function extendedFocusMethod(options) {
  this.nativeFocusMethod(options);
  if (!(options == null ? void 0 : options.disableFocusVisible)) {
    if (this.disabled) {
      removeFocusVisible(this);
    } else {
      addFocusVisible(this);
    }
  }
  this.onblur = () => removeFocusVisible(this);
}
if (typeof HTMLElement !== "undefined" && !HTMLElement.prototype.nativeFocusMethod) {
  HTMLElement.prototype.nativeFocusMethod = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = extendedFocusMethod;
}
export {
  addFocusVisible,
  focusVisibleClass,
  removeFocusVisible
};
